import { Pipe, PipeTransform } from '@angular/core';
import { Rect } from '../../classes/rect.class';

@Pipe({
  name: 'isVeryBottom',
})
export class IsVeryBottomPipe implements PipeTransform {
  transform(bounds: Rect, index: number, positions: { bounds: Rect }[]): boolean {
    if (!bounds) return false;
    const bottom = bounds.y + bounds.height;
    return !positions.slice(index + 1).some(pos => pos.bounds.y === bottom && pos.bounds.x === bounds.x);
  }
}
